import { classNames } from "zeta-dom-react";
import { backgroundImage, handleDoubleClick, linkAttr, openWindow } from "src/util/common";
import { ConfirmDialogProps, GridItem, GridItemProps, Icon, openConfirmDialog } from ".";

interface LinkItem {
    id?: string;
    icon?: string;
    url: string;
    title: string;
    description?: string;
    target?: React.HTMLAttributeAnchorTarget;
    arrowType?: 'arrowRight' | 'arrowRight2';
    dialog?: Omit<ConfirmDialogProps, 'onCommit'>;
}

export function ArrowedLinkGridItem(props: LinkItem & React.PropsWithoutRef<GridItemProps>) {
    const { id, url, title, description, icon, arrowType, target, dialog, ..._props } = props;
    return (
        <GridItem {..._props} className={classNames('eac-grid-item-link', props.className)} style={backgroundImage(icon || '')}>
            {!dialog ?
                <a data-id={id} {...linkAttr(url, target)} onClick={(e: any) => { handleDoubleClick(e, url) }}>
                    <div className="eac-grid-item-link-text">
                        <span>{title}</span>
                        <small>{description}</small>
                    </div>
                    <Icon icon={arrowType || 'arrowRight'} />
                </a> :
                <div data-id={id} onClick={openDialog}>
                    <div className="eac-grid-item-link-text">
                        <span>{title}</span>
                        <small>{description}</small>
                    </div>
                    <Icon icon={arrowType || 'arrowRight'} />
                </div>
            }
        </GridItem>
    );

    function openDialog() {
        openConfirmDialog({
            ...dialog!,
            onCommit(value) {
                if (value) {
                    if (linkAttr(url, target).target === '_blank') {
                        openWindow(url);
                    } else {
                        window.location.href = url;
                    }
                }
            }
        });
    }
}
